import React from 'react';
import { SearchByPropertyResultItem } from 'pages/Search/models';
import { Table, Typography, Button } from 'antd';
import { PropertyAddress, PropertyOwner } from 'pages/common/models/index';
import { CommonTable } from 'common';

const { Title, Text } = Typography;
const { Column } = Table;

const ResultTable: React.FC<{
  result: SearchByPropertyResultItem;
  searchCriteria: string;
  onClickDetails: any;
}> = (props: {
  result: SearchByPropertyResultItem;
  searchCriteria: string;
  onClickDetails: any;
}) => {
  const count = props.result.listOfProperties.length;
  const resultsNoun = count === 1 ? 'result' : 'result';

  return (
    <>
      <Title level={4}>Search Criteria: {props.searchCriteria}</Title>
      <Text>
        Your search has returned {count} {resultsNoun}
      </Text>
      <CommonTable items={props.result.listOfProperties} rowKey="apn">
        <Column title="County" dataIndex="county" width="8rem" />
        <Column title="Block" dataIndex="block" width="4rem" />
        <Column title="Lot" dataIndex="lot" width="4rem" />
        <Column title="Easement" dataIndex="ease" width="6rem" />
        <Column
          title="Addresses"
          dataIndex="addresses"
          render={(record: PropertyAddress[]) =>
            record.map((address: PropertyAddress, index: number) => {
              //put string's to table to filter it out and then join the rest of it which are not empty
              const textToDisplay = [
                address.houseNumber,
                address.street,
                address.streetUnit,
                address.city,
                address.postCode,
              ]
                .filter((x) => typeof x === 'string' && x.length > 0)
                .join(' ');

              return (
                <React.Fragment key={`propertyAddress${index}`}>
                  <Text>{textToDisplay}</Text>
                  <br />
                </React.Fragment>
              );
            })
          }
        />
        <Column
          width="15rem"
          title="Owners"
          dataIndex="owners"
          render={(record: PropertyOwner[]) =>
            record.map((owner: PropertyOwner, index: number) => {
              return (
                <React.Fragment key={`propertyOwner${index}`}>
                  <Text>{owner.name}</Text>
                  <br />
                </React.Fragment>
              );
            })
          }
        />
        <Column
          width="6rem"
          title="Action"
          render={(text: string, record: any) => (
            <Button
              type="link"
              size="small"
              icon="file-search"
              onClick={() => props.onClickDetails(record)}
            >
              Details
            </Button>
          )}
        />
      </CommonTable>
    </>
  );
};

export default React.memo(ResultTable);
